// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);
}

.card {
  width: 300px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.dashboard-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.dashboard-card {
  height: auto;
  width: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.report-div {
  width: 100vw;
  height: 90vh;
  margin-top: 10vh; /* Used to remove the "Free trial" banner with -4vh */
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.card h2 {
  margin-bottom: 20px;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

label {
  margin-bottom: 5px;
  text-align: left;
}

input {
  padding: 8px;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
}


/* Login.css */

.main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: rgb(0,0,0);
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);
}

.left-box {
  display: flex;
  width: 300px;
  height: 300px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
}

.left-box img {
  max-width: 90%;
  max-height: 150px;
  align-self: center;
  margin-top: 128px;
}

.left-box {
  background-color: #000000;
  text-align: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.right-box {
  width: 300px;
  height: 300px;
  background-color: #ffffff11;
  text-align: left;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-family: "Monaco", monospace;
}

.right-box-label {
  display: flex;
  width: 220px;
  flex-direction: column;
  margin-top: 65px;
}

@media (prefers-color-scheme: light) {
  .right-box-label {
    color: #ffffff;
  }

  .right-box-label2 {
    color: #ffffff;
  }
}

.right-box-label2 {
  display: flex;
  width: 220px;
  flex-direction: column;
  margin-top: 0px;
}

.right-box input {
  margin-bottom: 10px;
  width: 90%;
  padding: 10px;
  border: 1px solid #242424;
  border-radius: 5px;
}

.right-box button {
  width: 30%;
  padding: 5px;
  margin-top: 25px;
  background-color: #ffffff;
  color: #000000;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Monaco", monospace;
  transition: all 0.25s ease-in-out;
}

.right-box button:hover {
  width: 30%;
  padding: 5px;
  margin-top: 25px;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Monaco", monospace;
}

/* SelectDashboard.css */

.center-buttons button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
  transition: all 0.25s ease-in-out;
}

.center-buttons button:hover {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  color: #ffffff;
  border: 1px solid #ccc;
  border-color: 1px solid #ccc;
}


/* ViewDashboard.css */

.dashboard-container{
  width: 99%;
  height: 96vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);
}

.horizontal-bar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  background-color: #000000;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
}

.logout-button {
  background-color: transparent;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB,EAAE,qDAAqD;EACvE,UAAU;EACV,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA,cAAc;;AAEd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA,wBAAwB;;AAExB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;AAC9B;;;AAGA,sBAAsB;;AAEtB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);\n}\n\n.card {\n  width: 300px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.dashboard-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.dashboard-card {\n  height: auto;\n  width: auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.report-div {\n  width: 100vw;\n  height: 90vh;\n  margin-top: 10vh; /* Used to remove the \"Free trial\" banner with -4vh */\n  padding: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.card h2 {\n  margin-bottom: 20px;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nlabel {\n  margin-bottom: 5px;\n  text-align: left;\n}\n\ninput {\n  padding: 8px;\n  margin-bottom: 10px;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n\n\n/* Login.css */\n\n.main-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: rgb(0,0,0);\n  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);\n}\n\n.left-box {\n  display: flex;\n  width: 300px;\n  height: 300px;\n  text-align: center;\n  align-items: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.left-box img {\n  max-width: 90%;\n  max-height: 150px;\n  align-self: center;\n  margin-top: 128px;\n}\n\n.left-box {\n  background-color: #000000;\n  text-align: center;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.right-box {\n  width: 300px;\n  height: 300px;\n  background-color: #ffffff11;\n  text-align: left;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  font-family: \"Monaco\", monospace;\n}\n\n.right-box-label {\n  display: flex;\n  width: 220px;\n  flex-direction: column;\n  margin-top: 65px;\n}\n\n@media (prefers-color-scheme: light) {\n  .right-box-label {\n    color: #ffffff;\n  }\n\n  .right-box-label2 {\n    color: #ffffff;\n  }\n}\n\n.right-box-label2 {\n  display: flex;\n  width: 220px;\n  flex-direction: column;\n  margin-top: 0px;\n}\n\n.right-box input {\n  margin-bottom: 10px;\n  width: 90%;\n  padding: 10px;\n  border: 1px solid #242424;\n  border-radius: 5px;\n}\n\n.right-box button {\n  width: 30%;\n  padding: 5px;\n  margin-top: 25px;\n  background-color: #ffffff;\n  color: #000000;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Monaco\", monospace;\n  transition: all 0.25s ease-in-out;\n}\n\n.right-box button:hover {\n  width: 30%;\n  padding: 5px;\n  margin-top: 25px;\n  background-color: #000000;\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: \"Monaco\", monospace;\n}\n\n/* SelectDashboard.css */\n\n.center-buttons button {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  color: #000000;\n  transition: all 0.25s ease-in-out;\n}\n\n.center-buttons button:hover {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000000;\n  color: #ffffff;\n  border: 1px solid #ccc;\n  border-color: 1px solid #ccc;\n}\n\n\n/* ViewDashboard.css */\n\n.dashboard-container{\n  width: 99%;\n  height: 96vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(69,69,70,1) 100%);\n}\n\n.horizontal-bar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 50px;\n  background-color: #000000;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 20px;\n}\n\n.logout-button {\n  background-color: transparent;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
